import { Text } from 'ui-kit/typography'
import { Picture } from 'ui-kit/picture'
import { UniversalIntegrationsContent } from '../Content'
import { contentData } from '../Content/contentData'
import CustomizeDesk1x from './customize-desk@1x.png'
import CustomizeDesk2x from './customize-desk@2x.png'
import CustomizeMob1x from './customize-mob@1x.png'
import CustomizeMob2x from './customize-mob@2x.png'
import clsx from 'clsx'
import classes from './UniversalIntegrationsCreate.module.scss'

export const UniversalIntegrationsCreate = () => {
  return (
    <section className={classes.section}>
      <div className={classes.wrapper}>
        <UniversalIntegrationsContent item={contentData[2]} />

        <div className={classes.visual}>
          <div className={classes.box}>
            <Text
              as={'span'}
              className={clsx(classes.box__inner, classes.box__inner1)}
            >
              Provides default implementation for
            </Text>
            <Text
              as={'span'}
              className={clsx(classes.box__inner, classes.box__inner2)}
            >
              Provides default implementation for
            </Text>
            <Text
              className={clsx(
                classes.box__inner,
                classes.box__bottom,
                classes.box__bottom1,
              )}
            >
              <Text
                as={'span'}
                size={'lg'}
                lh={'loose'}
                className={classes.box__bottomTitle}
              >
                Universal Integrations
              </Text>
              <Text
                as={'span'}
                lh={'loose'}
                className={classes.box__bottomText}
              >
                Integration scenarios unique to a single external app
              </Text>
            </Text>
            <Text
              className={clsx(
                classes.box__inner,
                classes.box__bottom,
                classes.box__bottom2,
              )}
            >
              <Text
                as={'span'}
                size={'lg'}
                lh={'loose'}
                className={classes.box__bottomTitle}
              >
                App-level Integrations
              </Text>
              <Text
                as={'span'}
                lh={'loose'}
                className={classes.box__bottomText}
              >
                Integration scenarios unique to a single external app
              </Text>
            </Text>
            <Text
              className={clsx(
                classes.box__inner,
                classes.box__bottom,
                classes.box__bottom3,
              )}
            >
              <Text
                as={'span'}
                size={'lg'}
                lh={'loose'}
                className={classes.box__bottomTitle}
              >
                Customer-level Integrations
              </Text>
              <Text
                as={'span'}
                lh={'loose'}
                className={classes.box__bottomText}
              >
                Integration scenarios applied to an individual customer and
                connection
              </Text>
            </Text>
            <Picture
              className={classes.image}
              mobSrc1x={CustomizeMob1x.src}
              mobSrc2x={CustomizeMob2x.src}
              deskSrc1x={CustomizeDesk1x.src}
              deskSrc2x={CustomizeDesk2x.src}
              deskBreakpoint={992}
              width={296}
              height={1334}
              alt='Customize integrations for individual customers if necessary'
              lazyLoad
            />
          </div>
        </div>
      </div>
    </section>
  )
}
